import { render, staticRenderFns } from "./FeedbackOptions.vue?vue&type=template&id=711b6365&scoped=true&"
import script from "./FeedbackOptions.vue?vue&type=script&lang=js&"
export * from "./FeedbackOptions.vue?vue&type=script&lang=js&"
import style0 from "./FeedbackOptions.vue?vue&type=style&index=0&id=711b6365&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "711b6365",
  null
  
)

export default component.exports